// extracted by mini-css-extract-plugin
module.exports = {"page":"Webinar_page__1610H","photo":"Webinar_photo__2oLpj","button":"Webinar_button__4C_HL","disabled":"Webinar_disabled__2gD69","buttons":"Webinar_buttons__2AEmX"};